import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { PageHeader } from "@/components/PageHeader";
import { User, Lock, Bell } from "lucide-react";

export const Route = createFileRoute("/settings")({
  head: () => ({ meta: [{ title: "Configurações — Viny Club" }] }),
  component: SettingsLayout,
});

const tabs = [
  { to: "/settings/profile", label: "Perfil", icon: User },
  { to: "/settings/notifications", label: "Notificações", icon: Bell },
  { to: "/settings/account", label: "Conta", icon: Lock },
] as const;

function SettingsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const bare = pathname.startsWith("/settings/billing") || pathname.startsWith("/settings/performance");
  if (bare) {
    return (
      <AppShell>
        <div className="mx-auto w-full max-w-[1400px] px-4 pb-8 pt-4 lg:px-5">
          <Outlet />
        </div>
      </AppShell>
    );
  }
  return (
    <AppShell>
      <PageHeader eyebrow="Conta" title="Configurações" />
      <div className="mx-auto w-full max-w-[1400px] px-4 pb-8 lg:px-5">
        <div className="mb-6 flex flex-wrap gap-2 border-b border-border pb-2">
          {tabs.map((t) => {
            const active = pathname.startsWith(t.to);
            const Icon = t.icon;
            return (
              <Link
                key={t.to}
                to={t.to}
                className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium ${
                  active
                    ? "bg-primary text-primary-foreground"
                    : "text-muted-foreground hover:text-foreground"
                }`}
              >
                <Icon className="h-4 w-4" /> {t.label}
              </Link>
            );
          })}
        </div>
        <Outlet />
      </div>
    </AppShell>
  );
}
